import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 99999999999999;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #fff;
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
  border-radius: 5px;
  padding: 10px 20px;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;

  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
`;

export const ModalContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 20px;

  h1 {
    font-size: 20px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 500px;
  text-align: center;

  h1 {
    margin-bottom: 24px;
  }

  button.btn-cancel {
    background-color: #c53030;
  }

  div.input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    p {
      font-size: 1rem;
      font-weight: 500;
      margin: 15px 0 3px 5px;

      span {
        font-size: 0.8rem;
        // font-weight: 500;
        color: #455a64;
      }

      span.span-obr {
        color: red;
        font-size: 1rem;
      }
    }
  }
`;
